/**
 * Message of a failed admin call: the API's own message when there is one.
 */
export const errorMessage = (e: unknown, t: (_key: string) => string): string => {
  const error: any = e;
  return (
    error?.response?.data?.message ||
    error?.errors?.[0]?.error ||
    error?.message ||
    t('mdsUnknownError')
  );
};
